import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { MedicalAppointmentValidation } from "../../model/medical-appointment-validation";
import { ValorizationEdit } from "../../model/valorization-edit";
import { MedicalOrder } from "../../model/medical-order";
import { MedicalAppointment } from "../../model/medical-appointment";
import { Reservation } from "../../model/reservation";
import { ServiceReservation } from "src/app/model/service-reservation";
import { MedicalAppointmentValidationProcedure } from "src/app/model/medical-appointment-validation-procedure";

@Injectable({
  providedIn: "root",
})
export class OnLineValidationService {
  constructor(private dataService: DataService) {}

  private readonly getValidationProceduresEndPoint: string =
    "/onLineValidation/GetMedicalAppointmentProcedureValidation/";

  private readonly executeOnLineOperationEndPoint: string =
    "/onLineValidation/executeOnLineOperation/";
  private readonly executeOnLineOperationInReservationEndPoint: string =
    "/onLineValidation/executeOnLineOperationInReservation/";
  private readonly executePreAuthorizationEndPoint: string =
    "/onLineValidation/executePreAuthorization/";
  private readonly changeValidationReferenceNumberEndPoint: string =
    "/onLineValidation/changeValidationReferenceNumber/";

  async changeValidationReferenceNumber(
    medicalAppointmentId: number,
    validationReferenceNumber: string
  ): Promise<boolean> {
    const request = {
      MedicalAppointmentId: medicalAppointmentId,
      ValidationReferenceNumber: validationReferenceNumber,
    };

    return await this.dataService
      .post<boolean>(this.changeValidationReferenceNumberEndPoint, request)
      .toPromise();
  }

  async executePreAuthorization(
    serviceReservation: ServiceReservation,
    patientId: number
  ): Promise<MedicalAppointmentValidation> {
    const request = {
      ServiceReservation: serviceReservation,
      PatientId: patientId,
    };

    return await this.dataService
      .post<MedicalAppointmentValidation>(
        this.executePreAuthorizationEndPoint,
        request
      )
      .toPromise();
  }

  async executeOnLineOperationInReservation(
    serviceReservation: ServiceReservation,
    patientId: number
  ): Promise<MedicalAppointmentValidation> {
    const request = {
      ServiceReservation: serviceReservation,
      PatientId: patientId,
    };

    return await this.dataService
      .post<MedicalAppointmentValidation>(
        this.executeOnLineOperationInReservationEndPoint,
        request
      )
      .toPromise();
  }

  async executeOnLineOperationFromAppointments(
    appointmentIds: number[],
    credential: string,
    token: string,
    preAuth: string
  ): Promise<void> {
    const request = {
      appointmentIds,
      credential,
      token,
      preAuth,
    };
    await this.dataService
      .post<void>(
        "/onLineValidation/ExecuteOnLineOperationFromAppointments/",
        request
      )
      .toPromise();
  }

  async getValidationProcedures(
    medicalAppointment: MedicalAppointment,
    medicalOrder: MedicalOrder,
    valorizationEdit: ValorizationEdit
  ): Promise<MedicalAppointmentValidationProcedure[]> {
    const request = {
      medicalAppointment,
      medicalOrder,
      valorizationEdit,
    };
    const resp = await this.dataService
      .post<MedicalAppointmentValidationProcedure[]>(
        this.getValidationProceduresEndPoint,
        request
      )
      .toPromise();

    return resp;
  }

  async executeOnLineOperation(
    medicalAppointment: MedicalAppointment,
    medicalOrder: MedicalOrder,
    valorizationEdit: ValorizationEdit,
    medicalAppointmentValidation: MedicalAppointmentValidation = null
  ): Promise<MedicalAppointmentValidation> {
    const request = {
      medicalAppointment,
      medicalOrder,
      valorizationEdit,
      medicalAppointmentValidation,
    };
    const resp = await this.dataService
      .post<MedicalAppointmentValidation>(
        this.executeOnLineOperationEndPoint,
        request
      )
      .toPromise();

    return resp;
  }
}
